export default __webpack_public_path__ + "static/media/blazedmutantapes_preview3.3764ee68.jpg";